
import './App.css';
import Navigation from "./Navigation";
export default function About(){
    
    return(
        <>
        {Navigation()}
        <h1 id='credits-m'>About:</h1>
        <hr/>
            <h5>Full and foremost purpose of building this website is providing <br/>
            convinience in access to all sort of learning sources.This website<br/>
            gives you the compilation of study materials regarding listed <br/>
            courses. Kindly contact us for any sort of changes, updation or <br/>
            suggestion. Thanking You!</h5>
        </>
    );
}